// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"dea74bec","439":"40ed4c99","606":"d18f20dc","808":"8ba9961f","986":"510b5367"}[chunkId] + ".chunk.js";
};